









































import { computed, defineComponent, watch } from '@vue/composition-api';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { useDigestsStore } from '../store/GroupDigests';
import DigestForm from './DigestForm.vue';
import { DigestFormOutput } from './digestForm';

export default defineComponent({
	components: {
		SlidingPanel,
		LoaderState,
		DigestForm,
		ErrorCard,
		SuccessCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedDigestId: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const digestsStore = useDigestsStore();
		const digest = computed(() => digestsStore.getById(props.groupId, props.selectedDigestId));
		const {
			track,
			isLoading,
			isError,
		} = useAsyncStatus();
		watch(() => [props.groupId, props.selectedDigestId], ([groupId, digestId]) => {
			if (!groupId || !digestId) {
				return;
			}
			if (!digestsStore.getById(props.groupId, props.selectedDigestId)) {
				track(digestsStore.fetchFullDigest(props.selectedDigestId));
			}
		}, { immediate: true });

		// Submission
		const {
			track: trackSubmission,
			isLoading: isSavingUpdates,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();
		const submit = (payload: DigestFormOutput) => {
			trackSubmission(useDigestsStore().updateDigest(props.groupId, props.selectedDigestId, payload));
		};

		return {
			// Primary state
			digest,
			isLoading,
			isError,
			// Edit submission
			submit,
			isSavingUpdates,
			isErrorSavingUpdates,
			isSuccessSavingUpdates,
		};
	},
});
